import React from "react";
import styles from "./leadCardDetails.module.scss"
import { getFormatedDateWithMonthText } from "../../utils/common/CommonFunctions";


const LeadCardDetails = ({ item }) => {
    const getDateAndMonth = (data) => {
        const getdata = getFormatedDateWithMonthText(data)
        return getdata;
    }

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.container}>
                <h3 className={styles.name}>{item?.name}</h3>
                <p className={styles.email}><strong>Email:</strong> {item?.email}</p>
                <p className={styles.phone}><strong>Phone:</strong> {item?.mobileNumber
                }</p>
                <p className={styles.subject}><strong>Subject:</strong> {item?.subject}</p>
                <p className={styles.message}><strong>Message:</strong> {item?.message}</p>
                <p className={styles.date}><strong>Created At:</strong> {getDateAndMonth(item?.createdAt)} </p>
            </div>
        </div>
    );
};

export default LeadCardDetails;